<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="options"
    :custom-label="label"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="true"
    :preselectFirst="true"
    :loading="isLoading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
    <template slot="placeholder">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'emptyLabel', 'includeAll', 'localidadeWebSelecionada'],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'id_template_metodo_pagamento', null);
        return;
      }
      this.$emit('selectChange', 'id_template_metodo_pagamento', e.id);
      this.$emit('focus');
    },
    label({ nome }) {
      return nome;
    },
    setValue(value) {
      if (value) {
        this.selected = this.options.find((option) => option.id === value);
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      let filterString = ` localidade_web.id_empresa=${this.$store.state.user.info.id_empresa} and `;
      filterString += ' excluido=false ';

      if (this.localidadeWebSelecionada) {
        filterString += ` and id_localidade_web=${this.localidadeWebSelecionada} `;
      }

      this.$atenaList
        .getCommon('template_metodo_pagamento', {
          columns: 'id, nome',
          filter: filterString,
          order: 'id'
        })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss" scoped></style>
